import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { GenericSubSection } from '../common/GenericSubSection';
import { useUnderHoodSection } from '../../hooks/useUnderHoodSection';

export const UnderHood = () => {
  const { section, images } = useUnderHoodSection();

  return (
    <Level2Wrapper flex="1 1 100%" label="Under Hood">
      <ImageList label="Under Hood Pictures" images={images} />
      {Object.values(section?.subsections ?? {}).map(sub => (
        <GenericSubSection key={sub.id} section={sub} />
      ))}
    </Level2Wrapper>
  );
};
